import { connect } from 'react-redux';
import PersonaCreatorMultiSegments from './personaCreatorMultiSegments';

const mapStateToProps = state => (
  {
    multiClusterSegmentsData:
    state.insight360.personaCreator.multiClusterSegments,
    originalSegmentsData: state.insight360.personaCreator.segments,
    selectedExpressionObject: state.insight360.personaCreator
    .clusterSegments.selectedExpressionObject,
  }
);

const mapDispatchToProps = () => {};

/**
 *  Sends functions to component
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonaCreatorMultiSegments);
